import { endOfMonth } from 'date-fns';
import { convertZonedDateToSystemDate, convertSystemDateToZonedDate } from './DateUtils2.js';
import { gregorianToHijri, getHijriMonthDaysNumber, hijriToGregorian } from './DateUtils38.js';

const getTzEndOfMonth = (tzDate, calendar = 'gregorian') => {
    const systemDate = convertZonedDateToSystemDate(tzDate);
    const newDate = endOfMonth(systemDate);
    if (calendar === 'gregorian')
        return convertSystemDateToZonedDate(newDate);
    const hijriSystemDate = gregorianToHijri(systemDate);
    const daysNumber = getHijriMonthDaysNumber(hijriSystemDate.month, hijriSystemDate.year);
    const gregorianEndOfHijriMonth = hijriToGregorian(daysNumber, hijriSystemDate.month, hijriSystemDate.year);
    return convertSystemDateToZonedDate(gregorianEndOfHijriMonth);
};

export { getTzEndOfMonth };
